import { Helmet } from 'react-helmet-async';
import { useLocales } from 'src/locales';
import GlobalTextAds from 'src/sections/overview/dashboards/views/globalTextAds';

// ----------------------------------------------------------------------

export default function Home() {
  const { t } = useLocales()
  return (
    <>
      <Helmet>
        <title>Text Ads</title>
      </Helmet>

      <GlobalTextAds />
    </>
  );
}